import { CheckCircle2, Circle } from "lucide-react";

export function OnboardingChecklist({ data, testid = "onboarding-checklist" }) {
  if (!data) return null;
  const { items = [], progress = 0, done = 0, total = 0, completed = false } = data;
  return (
    <div className="space-y-4" data-testid={testid}>
      <div>
        <div className="flex items-center justify-between text-sm">
          <span className="font-semibold">
            Onboarding {completed ? "complete" : "progress"}
          </span>
          <span data-testid={`${testid}-progress`} className="tabular-nums text-muted-foreground">
            {done}/{total} · {progress}%
          </span>
        </div>
        <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-muted">
          <div
            className="h-full rounded-full bg-[#B28A3D] transition-all"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
      <ul className="space-y-1.5">
        {items.map((it) => (
          <li key={it.key} data-testid={`${testid}-item-${it.key}`}
            className="flex items-start gap-2.5 rounded-md border bg-card/50 px-3 py-2 text-sm">
            {it.done
              ? <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
              : <Circle className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />}
            <div className="min-w-0">
              <div className={it.done ? "" : "text-muted-foreground"}>{it.label}</div>
              {it.detail ? <div className="truncate text-xs text-muted-foreground">{it.detail}</div> : null}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
